module.exports = __webpack_public_path__ + "img/49.e3966c4a.webp";